const de = {
    product_identification:'Eindeutiger Kenncode des Produkttyps:',
    manufacturer: 'Hersteller und Bevollmächtigter Vertreter',
    product_type:'Produkttyp auswählen',

    core_type:'Kernmaterial auswählen:',

    application:'Verwendungszweck',

    system:'System(e) zur Bewertung und Überprüfung der Leistungsbeständigkeit:',

    harmonized_standard:'Harmonisierte Norm:',

    notified_body:'Notifizierte Stelle(n):',

    technical_document:'Europäisches Bewertungsdokument:',

    fire_and_resistance:'II) Brandverhalten:',

    fire_reaction:'Brandverhalten',

    declaration:'Leistungserklärung',

    face_back_material:'Material der Außen-/Innenbeschichtung',

// MAIN SECTIONS
    basic_information: 'Allgemeine Informationen',
    fire_resistance: 'Brandverhalten und Feuerbeständigkeit',
    material: 'Material',
    characteristics: 'Wesentliche Merkmale',

// TABLE HEADERS
    characteristic: 'Wesentliche Merkmale',
    value: 'Wert',
    standard: 'Dokument / Norm',

// CHARACTERISTICS
    u_value:
        'VI) Wärmedurchgangskoeffizient U-Wert',

    lambda:
        'VII) Wärmeleitfähigkeitskoeffizient des Kerns',

    mechanical_resistance:
        'VIII) Mechanische Festigkeit',

    zatezna_cvrstoca:
        'a) Zugfestigkeit',

    modul_zatezanja:
        'b) Elastizitätsmodul bei Zug',

    zatezna_temp:
        'c) Zugfestigkeit bei erhöhter Temperatur',

    modul_temp:
        'd) Elastizitätsmodul bei erhöhter Temperatur',

    pritisna:
        'e) Druckfestigkeit',

    modul_pritiska:
        'f) Druckmodul',

    smicanje:
        'g) Scherfestigkeit',

    smicanje_dugotrajno:
        'h) Reduzierte langfristige Scherfestigkeit',

    modul_smicanja:
        'i) Schubmodul',

    puzanje_2000:
        'j) Kriechkoeffizient t=2.000h',

    puzanje_100000:
        'k) Kriechkoeffizient t=100.000h',

    l_group:
        'l) Biegemomenttragfähigkeit eines einfach gelagerten Paneels',

    l_pozitivno:
        'Positiv',

    l_pozitivno_temp:
        'Positiv, erhöhte Temperatur',

    l_negativno:
        'Negativ',

    l_negativno_temp:
        'Negativ, erhöhte Temperatur',

    m_group:
        'm) Verhältnis zwischen Biegemoment und Auflagerreaktionen',

    m_kapacitet:
        'Biegemomenttragfähigkeit',

    m_pozitivno:
        'Positiv',

    m_pozitivno_temp:
        'Positiv, erhöhte Temperatur',

    m_negativno:
        'Negativ',

    m_negativno_temp:
        'Negativ, erhöhte Temperatur',

    n_group:
        'n) Beulspannung - oberes Blech',

    n_u_polju:
        'Im Feld',

    n_u_polju_temp:
        'Im Feld, erhöhte Temperatur',

    n_srednji_oslonac:
        'An Zwischenauflager',

    n_srednji_oslonac_temp:
        'An Zwischenauflager, erhöhte Temperatur',

    o_group:
        'o) Beulspannung - unteres Blech',

    o_u_polju:
        'Im Feld',

    o_srednji_oslonac:
        'An Zwischenauflager',

    ix_pozar:
        'IX) Äußere Brandeinwirkung',

    x_voda:
        'X) Wasserdichtheit',

    xi_zrak:
        'XI) Luftdurchlässigkeit',

    xii_para:
        'XII) Wasserdampfdurchlässigkeit',

    xiii_zvuk:
        'XIII) Luftschalldämmung',

    xiv_apsorpcija:
        'XIV) Schallabsorption',

    xv_trajnost:
        'XV) Dauerhaftigkeit',

    xvi_test:
        'XVI) Prüfung der Befestigungselemente',

    dokumentacija:
        '8. Geeignete technische Dokumentation und/oder spezielle technische Dokumentation',

    signed_for: 'Unterzeichnet für und im Namen des Herstellers durch:',

    footer_declaration:
        'Die oben beschriebenen Leistungen des Produkts entsprechen dem Satz der erklärten Leistungen. Diese Leistungserklärung wird gemäß der Bauproduktenverordnung Nr. 305/2011 unter der alleinigen Verantwortung des oben genannten Herstellers ausgestellt.' + '\n\n' +

        '1 Die Prüfunterlagen zur Feuerwiderstandsfähigkeit werden auf Anfrage des Kunden ausgestellt.' + '\n' +
        '2 Die Biegemomentkapazitäten gelten für eine Blechdicke von 0,4/0,4/0,4.' + '\n' +
        '3 Gemäß EN-14509, EN-13165 und den verwendeten Materialien wurde diese Eigenschaft ohne Prüfung bestätigt.',

    npd_translation:
        'Leistung nicht bestimmt',

    thickness: 'Dicke',
    general_manager: 'General Manager',

    toplotna_otpornost:
        'Wärmedurchlasswiderstand',

    toplotna_provodljivost:
        'Wärmeleitfähigkeit',

    tolerancije_debljine_group:
        'V) Dickentoleranzen',

    kategorija_tolerancije:
        'Toleranzklasse',

    plus_tolerancija:
        'Positive Toleranz [+mm]',

    minus_tolerancija:
        'Negative Toleranz [-mm]',

    reakcija_na_vatru_group:
        'VI) Brandverhalten',

    performance_class:
        'Leistungsklasse',

    smoke_classification:
        'Klassifizierung der Rauchentwicklung',

    flaming_droplets:
        'Klassifizierung brennender Tropfen',

    izdrzljivost_group:
        'VIII) Dauerhaftigkeit',

    dimenzionalna_stabilnost:
        'Dimensionsstabilität',

    deformacija_pod_opterecenjem:
        'Verformung unter Belastung',

    cvrstoca_na_pritisak:
        'IX) Druckfestigkeit (CS(10/Y)100, NPD)',

    cvrstoca_na_zatezanje:
        'X) Zugfestigkeit',

    vodopropusnost_group:
        'XII) Wasserdurchlässigkeit',

    kratkotrajna_apsorpcija_vode:
        'Kurzzeitige Wasseraufnahme',

    dugotrajna_djelimicna_apsorpcija:
        'Langzeitige teilweise Wasseraufnahme',

    dugotrajna_potpuna_apsorpcija:
        'Langzeitige vollständige Wasseraufnahme',

    ravnost_nakon_kvasenja:
        'Ebenheit nach Befeuchtung',

    paropropusnost:
        'XIII) Wasserdampfdurchlässigkeit',

    indeks_apsorpcije_zvuka:
        'XIV) Schallabsorptionsindex',

    ispustanje_opasnih_materija:
        'XV) Freisetzung gefährlicher Stoffe',

    kontinuirano_uzareno_izgaranje:
        'XVI) Kontinuierliches Glimmverhalten',

    application_14509_wall:
        'Metallbekleidetes wärmegedämmtes Sandwichelement für den Einsatz im Bauwesen - Wände und Wandverkleidungen',

    application_14509_roof:
        'Metallbekleidetes wärmegedämmtes Sandwichelement für den Einsatz im Bauwesen - Dächer und Dachverkleidungen',

    application_14509_coldroom:
        'Metallbekleidetes wärmegedämmtes Sandwichelement für den Einsatz im Bauwesen - Kühlraumpaneel',

    application_13165:
        'Wärmedämmplatten zur Verwendung im Bauwesen - Dämmung von Böden, Wänden und Dächern',
    laminirana_folija:
        'Laminierte Folie',

}
export default de